export default "__VITE_ASSET__Bp5EW88T__"